import { ThemeProperties } from '../../core';

export interface AttachmentTheme {
	baseBackground: string;
	baseBorderColor: string;
	baseBorderRadius: string;
	baseBoxShadow: string;
	basePadding: string;

	hoverBoxShadow: string;

	previewBackground: string;
	previewIconColor: string;

	nameFont: string;
	nameFontColor: string;

	metaFont: string;
	metaFontColor: string;
}

export const theme = new ThemeProperties('attachment');
